import React from 'react';
import CheckIcon from '@atlaskit/icon/core/migration/check-mark--check';
import CrossIcon from '@atlaskit/icon/core/migration/close--cross';
/*
  These styles are taken fro the spinner style for button. There was not an
  easy way to share tehm between the two components.
*/
export const spinnerStyles = {
  display: 'flex',
  position: 'absolute',
  // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage/preview
  left: '50%',
  // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage/preview
  top: '50%',
  transform: 'translate(-50%, -50%)'
};
export const ActionIcon = ({
  state
}) => {
  switch (state) {
    case 'init':
    case 'loading':
      return null;
    case 'success':
      return (
        /*#__PURE__*/
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        React.createElement("div", {
          "data-testid": "check-icon",
          style: spinnerStyles
        }, /*#__PURE__*/React.createElement(CheckIcon, {
          LEGACY_size: "small",
          label: "check",
          color: "currentColor"
        }))
      );
    case 'failure':
      return (
        /*#__PURE__*/
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        React.createElement("div", {
          "data-testid": "cross-icon",
          style: spinnerStyles
        }, /*#__PURE__*/React.createElement(CrossIcon, {
          LEGACY_size: "small",
          label: "check",
          color: "currentColor"
        }))
      );
  }
};